
/* System defined core library */
import { Injectable } from '@angular/core';
import { BootstrapParams } from '../../../bootstrap-params';
import { SiteSlot } from '../../shared/models/scheduling/siteSlot.model';
import { IMapMarker, IMapBounds, IMapRegion } from '../models/map.model';

@Injectable()
export class MapUtilityService {

    private _useBingMaps: boolean = false;

    constructor(private bootstrapParams: BootstrapParams) {
        this._useBingMaps = bootstrapParams.useBingMaps;
    }

    /**
     * Getter for getting bing maps config value
     */
    get useBingMaps(): boolean {
        return this._useBingMaps;
    }

    getMapMarkersFromSlots(siteSlots: SiteSlot[]): IMapMarker[] {
        return siteSlots.map((v) => {
            let mapMarker: IMapMarker = {
                id: v.id,
                latitude: v.location.coordinates[0],
                longitude: v.location.coordinates[1]
            };
            return mapMarker;
        });
    }

    /**
     * Get the bounding box for a set of lat, long points
     * Padding code: http://www.crowbarsolutions.com/adjusting-zoom-level-to-add-padding-to-map-bounding-boxes-bing-maps-v7/
     * @param arr
     */
    getMapBounds(arr: IMapMarker[]): IMapBounds {

        // get min and max values for lat and longs
        const latitudes: number[] = arr.map((v) => { return v.latitude });
        const longitudes: number[] = arr.map((v) => { return v.longitude });

        const minLatitude = Math.min(...latitudes);
        const maxLatitude = Math.max(...latitudes);
        const minLongtiude = Math.min(...longitudes);
        const maxLongitude = Math.max(...longitudes);

        // pad the bounding box size
        const pctBuffer = 0.1;
        const latBuffer = (maxLatitude - minLatitude) * pctBuffer;
        const lonBuffer = (maxLongitude - minLongtiude) * pctBuffer;

        return {
            minLatitude: minLatitude - latBuffer,
            maxLatitude: maxLatitude + latBuffer,
            minLongitude: minLongtiude - lonBuffer,
            maxLongitude: maxLongitude + lonBuffer
        };
    }

    getDummyRegion(): IMapRegion {
        return {
            lat: 39.2824,
            long: -76.70013
        };
    }

    getDummyData(): any[] {
        return [
            {
                "location": {
                    "coordinates": [
                        39.2824,
                        -76.60013
                    ],
                },
                "id": "9948",
            },
            {
                "location": {
                    "coordinates": [
                        39.28394,
                        -76.58924
                    ],
                },
                "id": "5315",
            },
            {
                "location": {
                    "coordinates": [
                        39.28522,
                        -76.56876
                    ],
                },
                "id": "0020",
            },
            {
                "location": {
                    "coordinates": [
                        39.27522,
                        -76.56876
                    ],
                },
                "id": "8987",
            },
            {
                "location": {
                    "coordinates": [
                        39.27522,
                        -76.56876
                    ]
                },
                "id": "9985",
            }
        ];
    }
}
